import { render, staticRenderFns } from "./MobileViewPage.vue?vue&type=template&id=7aa6a54a"
import script from "./MobileViewPage.vue?vue&type=script&lang=js"
export * from "./MobileViewPage.vue?vue&type=script&lang=js"
import style0 from "./MobileViewPage.vue?vue&type=style&index=0&id=7aa6a54a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports